var translations = {
  warnings: {
    straightRow: 'Les lignes droites de touches de votre clavier sont faciles à deviner',
    keyPattern: 'Des motifs de clavier courts sont faciles à deviner',
    simpleRepeat: "Les caractères répétés comme 'aaa' sont faciles à deviner",
    extendedRepeat: "Les caractères répétés comme 'abcabcabc' sont faciles à deviner",
    sequences: "Des séquences de caractères communs comme 'abc' sont faciles à deviner",
    recentYears: 'Les années récentes sont faciles à deviner.',
    dates: 'Les dates sont faciles à deviner.',
    topTen: 'Ce mot de passe est très utilisé.',
    topHundred: 'Ce mot de passe est fréquemment utilisé.',
    common: 'Ce mot de passe est couramment utilisé.',
    similarToCommon: 'Ce mot de passe est similaire à un mot de passe couramment utilisé.',
    wordByItself: 'Les mots simples sont faciles à deviner.',
    namesByThemselves: 'Des noms ou des prénoms simples sont faciles à deviner.',
    commonNames: 'Les noms communs et les noms de famille sont faciles à deviner.',
    userInputs: 'Le mot de passe ne doit pas comporter de données personnelles ou liées au site.',
    pwned: 'Votre mot de passe a été divulgué suite à une violation de données sur Internet.'
  },
  suggestions: {
    l33t: "Évitez les substitutions de lettres prévisibles comme '@' pour 'a'.",
    reverseWords: 'Évitez les orthographes inversées des mots courants',
    allUppercase: 'Mettez quelques lettres en majuscules, mais pas toutes.',
    capitalization: 'Capitalisez mais pas seulement la première lettre.',
    dates: 'Évitez les dates et les années qui vous sont associées. (ex: date ou année de naissance)',
    recentYears: 'Évitez les dernières années.',
    associatedYears: 'Évitez les années qui vous sont associées. (ex: date de naissance)',
    sequences: 'Évitez les séquences de caractères courantes.',
    repeated: 'Évitez les mots et les caractères répétés.',
    longerKeyboardPattern: 'Utilisez des motifs de clavier plus longs et changez de sens de frappe plusieurs fois.',
    anotherWord: 'Ajoutez des mots moins courants.',
    useWords: 'Utilisez plusieurs mots, mais évitez les phrases courantes.',
    noNeed: 'Vous pouvez créer des mots de passe forts sans utiliser de symboles, de chiffres ou de lettres majuscules.',
    pwned: 'Si vous utilisez ce mot de passe ailleurs, vous devriez le modifier.'
  },
  timeEstimation: {
    ltSecond: "moins d'une seconde",
    second: '{base} seconde',
    seconds: '{base} secondes',
    minute: '{base} minute',
    minutes: '{base} minutes',
    hour: '{base} heure',
    hours: '{base} heures',
    day: '{base} jour',
    days: '{base} jours',
    month: '{base} mois',
    months: '{base} mois',
    year: '{base} année',
    years: '{base} années',
    centuries: 'siècles'
  }
};

export { translations as default };
//# sourceMappingURL=translations.esm.js.map
